import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";

import type { IPackagesPrice } from "../../types";
import { TRANSLATION_KEYS } from "../constants";
import { getPackagesData } from "../getPackagesData";
import { useStepPackages } from "../useStepPackages";

import {
    Card,
    CheckmarkIcon,
    ChoosePlanButton,
    Container,
    Feature,
    FeatureList,
    FeatureText,
    PriceCaption,
    Tag,
    TagContainer,
    Title,
    TrialText,
} from "./styledComponent";

interface IPackageItemProps {
    packages?: IPackagesPrice;
}

export const PackageItem = ({ packages }: IPackageItemProps) => {
    const { translate } = useTranslate();
    const { onSubmitStep } = useStepPackages(packages);

    return (
        <Container data-automation="reactivation-packages-v2-cards">
            {getPackagesData(packages).map(({ title, recommendedTag, price, packageId, list }) => (
                <Card
                    key={packageId}
                    isRecommended={!!recommendedTag}
                    data-automation={`reactivation-packages-v2-card-${packageId}`}
                >
                    {recommendedTag ? (
                        <TagContainer>
                            <Tag
                                fontVariant="listItem1"
                                color={colorsPalettes.carbon[0]}
                            >
                                {translate(TRANSLATION_KEYS.recommendedText)}
                            </Tag>
                        </TagContainer>
                    ) : null}
                    <Title
                        fontVariant="tab"
                        color={colorsPalettes.carbon[500]}
                    >
                        {title}
                    </Title>

                    <TrialText
                        fontVariant="boldH4"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate(TRANSLATION_KEYS.textPrice)}
                    </TrialText>

                    <PriceCaption
                        fontVariant="body2"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate(TRANSLATION_KEYS.startsFrom, { price })}
                    </PriceCaption>

                    <ChoosePlanButton
                        width="100%"
                        onClick={() => onSubmitStep(packageId)}
                        data-automation={`reactivation-packages-v2-cta-${packageId}`}
                    >
                        {translate(TRANSLATION_KEYS.buttonText)}
                    </ChoosePlanButton>

                    <FeatureList>
                        {list.map((feature, index) => (
                            <Feature key={index}>
                                <CheckmarkIcon color={colorsPalettes.carbon[400]} />
                                <FeatureText
                                    fontVariant="body2"
                                    color={colorsPalettes.carbon[400]}
                                >
                                    {feature.item}
                                </FeatureText>
                            </Feature>
                        ))}
                    </FeatureList>
                </Card>
            ))}
        </Container>
    );
};
